module.exports = __webpack_public_path__ + "static/media/adgem.627b2cca.png";